import React from 'react'
import './footer.css'
function Footer() {
    return (
        <div className="footer">
            Made with ❤️ by Ranjeet
        </div>
    )
}

export default Footer
